import { render } from "./DashboardsPanel.vue?vue&type=template&id=4737ce26&scoped=true&ts=true"
import script from "./DashboardsPanel.vue?vue&type=script&lang=ts"
export * from "./DashboardsPanel.vue?vue&type=script&lang=ts"

import "./DashboardsPanel.vue?vue&type=style&index=0&id=4737ce26&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4737ce26"]])

export default __exports__